__webpack_require__.p = "/hotbox/content/frontend/release/";